import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import StatusContext from '../../../contexts/StatusContext';
import AITestContext from '../../../contexts/AITestContext';
//import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { PushButton } from '../pushbutton/PushButton';

export const DialogTestBought = () => {

  const [testname, setTestName] = useState('')
  
    let {
      changeLanguage,
    } = React.useContext(StatusContext);
    let {
      showTestBought,
      setShowTestBought,
    } = React.useContext(AITestContext);

  //let navigate = useNavigate();

  useEffect(() => {

    let buytestname = sessionStorage.getItem('buytestname')
    if (buytestname)
    {
      setTestName(buytestname)
      setShowTestBought(true)
    }
    }, [setShowTestBought])


   
  const handleOnClick = () => {
    setShowTestBought(false)
    sessionStorage.removeItem('buytestname', '')
    //navigate('/aitest')
  }

 

  return (
    <React.Fragment>
   
        <Dialog
          open={showTestBought}
         
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              
            },
          }}
        >

        <DialogTitle className="dialogProgressTitle" style = {{fontSize:'20px', color:'maroon'}}>{changeLanguage('aitest', 'buytesttitle')}</DialogTitle>

        <DialogContent dividers>
         
        <div className="signupPlans">
        
          
       
          <br></br>
          <div className="getcreditsText" style={{fontSize: '20px', fontWeight:'500'}}>
           
            {changeLanguage('aitest', 'buytesttext4')} "{testname}"
              <br></br>
              <br></br>
           
              <PushButton label={changeLanguage('dialog', 'ok')} onClick={handleOnClick}/>
              <br></br>
              <br></br>
              
          </div>
       
         </div>
          
        </DialogContent>
      </Dialog>
    </React.Fragment>
   
  )
}

export default DialogTestBought
